module.exports = __webpack_public_path__ + "static/media/call-or-email.2a453d18.svg";